import React, { useState, useEffect } from 'react';
import { Alert, Select, Avatar, Spin, DatePicker, Row, Col, Card, Tabs, Form, Input, Button, Upload, Icon, Skeleton, message } from 'antd';
import { getMyaccount, editMyaccount, uploadFile, updatePassword } from './../API';
import CustomAvatar from './../components/customAvatar';
import { allNations } from './../utils/countries';
import moment from 'moment';
import Flag from "react-country-flags";
import { useMappedState, useDispatch } from 'redux-react-hook';
import { uploadFileValidator } from './../utils';
import { buildInvoiceToLinkGlobal } from './../utils/buildInvoiceToLinkGlobal';
import { flexCenterRight, formItemLayout, nameStyle, roleStyle } from './../theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBirthdayCake } from '@fortawesome/free-solid-svg-icons'
import { faEdit, faKey, faFileImage, faFilePdf } from '@fortawesome/free-solid-svg-icons'

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { TabPane } = Tabs;
const { Option } = Select;

function UpdatePassword({ form }) {
  const session = useMappedState(state => state.session);
  const dispatch = useDispatch();

  const [pwdLoading, setPwdLoading] = useState(false);

  const { getFieldDecorator } = form;

  const handlePasswordSubmit = async e => {
    e.preventDefault();
    const formResult = await form.validateFields();
    const params = {
      password: formResult.newpassword
    };
    setPwdLoading(true);
    const result = await updatePassword(session.authToken, params);
    if (result.data.responseCode === 0) {
      message.success(`${result.data.message}, you will be logged out in 3 seconds`);
      setTimeout(() => {
        dispatch({ type: "CLEAR_SESSION" });
        dispatch({ type: "SET_INDEX", payload: "1" }); //reset highlight sidebar
      }, 3000)
    }
    else {
      message.error(result.data.message.toString());
    }
    setPwdLoading(false);
  }

  const handleConfirmPassword = (rule, value, callback) => {
    const { getFieldValue } = form;
    if (value && value !== getFieldValue('newpassword')) {
      callback('Confirm password not match!');
    }
    callback();
  }

  return (
    <Form onSubmit={handlePasswordSubmit}>
      <Row>
        <Col span={12}>
          <div style={{ marginRight: '10px' }}>

            <Form.Item
              labelCol={{ span: 9 }}
              wrapperCol={{ span: 15 }}
              label="New Password"
            >
              {getFieldDecorator('newpassword', {
                rules: [
                  { required: true, message: 'Please input new password!' },
                  {
                    min: 6,
                    message: 'Cannot be less than 6 characters',
                  }
                ],
              })(
                <Input
                  autoComplete="off"
                  placeholder="New Password"
                  disabled={pwdLoading}
                />
              )}
            </Form.Item>
          </div>
        </Col>

        <Col span={12}>
          <div style={{ marginLeft: '10px' }}>

            <Form.Item
              labelCol={{ span: 9 }}
              wrapperCol={{ span: 15 }}
              label="Confirm Password"
            >
              {getFieldDecorator('confirmpassword', {
                rules: [
                  { required: true, message: 'Please input confirm password!' },
                  {
                    validator: handleConfirmPassword
                  }
                ],
              })(
                <Input
                  autoComplete="off"
                  placeholder="Confirm Password"
                  disabled={pwdLoading}
                />
              )}
            </Form.Item>
          </div>
        </Col>
      </Row>

      <div style={flexCenterRight}>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            {pwdLoading ? <Icon type="loading" /> : <Icon type="check" />}
            Submit
          </Button>
        </Form.Item>
      </div>
    </Form>
  )
}

function MyAccount({ form }) {
  const nations = allNations();
  const { getFieldDecorator } = form;

  const session = useMappedState(state => state.session);
  const me = useMappedState(state => state.me);
  const dispatch = useDispatch();

  const [pdfURL, setPdfURL] = useState(null);

  const [avatarLoading, setAvatarLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      const response = await getMyaccount(session.authToken);
      dispatch({ type: "INIT_ME", payload: response.data.me });

      const template = await buildInvoiceToLinkGlobal();
      pdfMake.createPdf(template).getBuffer((buffer) => {
        const dataUrl = URL.createObjectURL(new Blob([buffer], {
          type: "application/pdf"
        }));
        setPdfURL(dataUrl);
      });


      setLoading(false);
    }
    dispatch({ type: "SET_INDEX", payload: "2" });
    fetchData();
    // eslint-disable-next-line
  }, []);

  const cardTitle = (
    <center>
      {
        !avatarLoading ?
          <CustomAvatar
            colourCode={session.firstname.charAt(0).toLowerCase()}
            char={`${session.firstname.charAt(0).toUpperCase()}${session.lastname.charAt(0).toUpperCase()}`}
            charSize={30}
            size={86}
            src={session.avatar}
          />
          :
          <Avatar size={86} style={{ backgroundColor: '#eeeeee' }}>
            <Spin indicator={<Icon type="loading" style={{ fontSize: 24 }} />} />
          </Avatar>
      }
      <div style={{ marginTop: "15px" }}>
        <p style={nameStyle}>
          {me.firstname} {me.lastname}
        </p>
        <p style={roleStyle}>
          {session.scope}
        </p>

        <Upload
          beforeUpload={(file) => {
            return uploadFileValidator(message, file, ['image/jpeg'], 4);
          }}
          showUploadList={false}
          customRequest={(e) => {
            setAvatarLoading(true);
            var reader = new FileReader();
            reader.readAsDataURL(e.file);

            reader.onload = function () {
              const imageData = reader.result.replace("data:image/jpeg;base64,", "")
              uploadFile(session.authToken,
                { file: imageData, name: `avatar/user/${session.id}.jpeg`, acl: 'public-read' }).then(x => {
                  setAvatarLoading(false);
                  e.onSuccess();
                  dispatch({ type: "UPDATE_USER_AVATAR" });
                })
            }
          }}>
          <Button size="small">
            {avatarLoading ? <Icon type="loading" /> : <Icon type="upload" />}
            Upload Avatar
          </Button>
        </Upload>

      </div>
    </center>
  )

  const handleSubmit = async e => {
    e.preventDefault();
    const formResult = await form.validateFields();
    setEditLoading(true);
    let requestData = {
      email: me.email,
      firstname: formResult.firstname,
      lastname: formResult.lastname,
      dob: formResult.dob ? formResult.dob.format('YYYY-MM-DD') : null,
      mobile: formResult.mobile,
      driveFolderID: formResult.driveFolderID,
      address: {
        address1: formResult.address1,
        address2: formResult.address2,
        city: formResult.city,
        country: formResult.country,
        postcode: formResult.postcode
      }
    }

    const result = await editMyaccount(session.authToken, requestData);
    setEditLoading(false);
    if (result.data.responseCode === 0) {
      dispatch({ type: "INIT_ME", payload: requestData });
      dispatch({ type: "UPDATE_USER_FULL_NAME", payload: requestData });
      message.success(result.data.message);
    }
    else {
      dispatch({ type: "OPEN_MSG_MODAL", payload: result.data.message });
    }
  };

  const countrySelection = [];
  for (let i = 0; i < nations.length; i++) {
    countrySelection.push(
      <Option key={i} value={nations[i].name} label={nations[i].name}>
        <Row>
          <Col span={4}>
            <Flag country={nations[i].code} asSquare={true} style={{ width: '30px', height: '20px' }} />
          </Col>
          <Col>
            {nations[i].name}
          </Col>
        </Row>
      </Option>
    )
  }

  return (
    loading ?
      <div>
        <p>Loading...</p>
        <Skeleton active />
      </div>
      :
      <div>
        <Row>
          <Col span={6}>
            <div style={{ marginRight: '5px' }}>
              <Card title={cardTitle} bordered={true}>
                <div style={{ marginTop: '-25px' }}>
                  <br />
                  <div><Icon type="mail" theme="filled" /> <b>Email</b></div>
                  <div>{me.email}</div>

                  {
                    me.dob && me.dob !== "" ?
                      <React.Fragment>
                        <br />
                        <div><FontAwesomeIcon icon={faBirthdayCake} />&nbsp;<b>Birthday</b></div>
                        <div>{moment(me.dob).format('YYYY-MM-DD')}</div>
                      </React.Fragment>
                      :
                      null
                  }

                  {
                    me.mobile && me.mobile !== "" ?
                      <React.Fragment>
                        <br />
                        <div><Icon type="mobile" theme="filled" /> <b>Mobile</b></div>
                        <div>{me.mobile}</div>
                      </React.Fragment>
                      :
                      null
                  }

                  {
                    me.address ?
                      me.address.address1 !== "" || me.address.address2 !== ""
                        || me.address.city !== "" || me.address.country !== "" || me.address.postcode !== "" ?
                        <React.Fragment>
                          <br />
                          <div><Icon type="home" theme="filled" /> <b>Address</b></div>
                          {
                            me.address.address1 !== "" ?
                              <div>{me.address.address1}</div>
                              :
                              null
                          }
                          {
                            me.address.address2 !== "" ?
                              <div>{me.address.address2}</div>
                              :
                              null
                          }
                          {
                            me.address.city !== "" ?
                              <div>{me.address.city}</div>
                              :
                              null
                          }
                          {
                            me.address.country !== "" ?
                              <div>{me.address.country}</div>
                              :
                              null
                          }
                          {
                            me.address.postcode !== "" ?
                              <div>{me.address.postcode}</div>
                              :
                              null
                          }
                        </React.Fragment>
                        :
                        null
                      :
                      null
                  }
                </div>
              </Card>
            </div>
          </Col>
          <Col span={18}>
            <div style={{ marginLeft: '5px' }}>
              <Tabs onChange={() => { }} type="card">
                <TabPane tab={
                  <span><FontAwesomeIcon icon={faEdit} /> Edit My Account</span>
                } key="1">
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col span={12}>
                        <div style={{ marginRight: '10px' }}>

                          <Form.Item {...formItemLayout} label="First name">
                            {getFieldDecorator('firstname', {
                              initialValue: me.firstname,
                              rules: [{ required: true, message: 'Please input your firstname!' }],
                            })(
                              <Input autoComplete="off" placeholder="First Name" disabled={editLoading} />
                            )}
                          </Form.Item>

                          <Form.Item {...formItemLayout} label="Last name">
                            {getFieldDecorator('lastname', {
                              initialValue: me.lastname,
                              rules: [{ required: true, message: 'Please input your lastname!' }],
                            })(
                              <Input autoComplete="off" placeholder="Last Name" disabled={editLoading} />
                            )}
                          </Form.Item>

                          <Form.Item {...formItemLayout} label="Birthday">
                            {getFieldDecorator('dob', {
                              initialValue: me.dob ? moment(me.dob) : null,
                            })(
                              <DatePicker placeholder="Date of Birth" style={{ width: "100%" }} disabled={editLoading} />
                            )}
                          </Form.Item>

                          <Form.Item {...formItemLayout} label="Mobile">
                            {getFieldDecorator('mobile', {
                              initialValue: me.mobile ? me.mobile : ''
                            })(
                              <Input autoComplete="off" placeholder="Mobile" disabled={editLoading} />
                            )}
                          </Form.Item>

                          <Form.Item {...formItemLayout} label="Google Drive">
                            {getFieldDecorator('driveFolderID', {
                              initialValue: me.driveFolderID ? me.driveFolderID : ''
                            })(
                              <Input autoComplete="off" placeholder="Google Drive Folder ID" disabled={editLoading} />
                            )}
                          </Form.Item>
                        </div>
                      </Col>

                      <Col span={12}>
                        <div style={{ marginLeft: '10px' }}>

                          <Form.Item {...formItemLayout} label="Address 1">
                            {getFieldDecorator('address1', {
                              initialValue: me.address ? me.address.address1 : ''
                            })(
                              <Input autoComplete="off" placeholder="Address 1" disabled={editLoading} />
                            )}
                          </Form.Item>

                          <Form.Item {...formItemLayout} label="Address 2">
                            {getFieldDecorator('address2', {
                              initialValue: me.address ? me.address.address2 : ''
                            })(
                              <Input autoComplete="off" placeholder="Address 2" disabled={editLoading} />
                            )}
                          </Form.Item>

                          <Form.Item {...formItemLayout} label="City">
                            {getFieldDecorator('city', {
                              initialValue: me.address ? me.address.city : ''
                            })(
                              <Input autoComplete="off" placeholder="City" disabled={editLoading} />
                            )}
                          </Form.Item>

                          <Form.Item {...formItemLayout} label="Country">
                            {getFieldDecorator('country', {
                              initialValue: me.address ? me.address.country : ''
                            })(
                              <Select
                                disabled={editLoading}
                                placeholder="Country"
                                optionLabelProp="label"
                                showSearch
                              >
                                {countrySelection}
                              </Select>
                            )}
                          </Form.Item>

                          <Form.Item {...formItemLayout} label="Post Code">
                            {getFieldDecorator('postcode', {
                              initialValue: me.address ? me.address.postcode : ''
                            })(
                              <Input autoComplete="off" placeholder="Post Code" disabled={editLoading} />
                            )}
                          </Form.Item>

                        </div>
                      </Col>
                    </Row>

                    <div style={flexCenterRight}>
                      <Form.Item>
                        <Button type="primary" htmlType="submit">
                          {editLoading ? <Icon type="loading" /> : <Icon type="check" />}
                          Submit
                        </Button>
                      </Form.Item>
                    </div>

                  </Form>
                </TabPane>
                <TabPane tab={
                  <span><FontAwesomeIcon icon={faKey} /> Update Password</span>
                } key="2">
                  <UpdatePasswordForm />
                </TabPane>
                {
                  session.scope === 'admin' ? (
                    <TabPane tab={
                      <span><FontAwesomeIcon icon={faFileImage} /> Link Global Icon</span>
                    } key="3">
                      <Alert
                        message="Admin Information"
                        description={
                          <div>
                            <div>Icon file from AWS is used for system generated email signature and CV PDF generator.</div>
                            <div>Icon file from Google Drive is used for email signature on web.</div>
                            <div>Make sure these two icon files should be identical.</div>
                          </div>
                        }
                        type="info"
                        showIcon
                      />
                      <center>
                        <br />
                        <br />
                        <img 
                          alt="lg-icon-aws" 
                          height="30" 
                          src="https://link-global-public.s3.eu-west-1.amazonaws.com/Link-Global.jpg"
                        />
                        <p>From AWS S3</p>
                        <br />
                        <br />
                        <img 
                          alt="lg-icon-google" 
                          height="30" 
                          src="https://drive.google.com/uc?id=1ylnreCuM0vBGCHko7dj6cuH4inKnNZ5h"
                        />
                        <p>From Google Drive</p>
                      </center>
                    </TabPane>
                  ) : null
                }
                {
                  session.scope === 'admin' ? (
                    <TabPane tab={
                      <span><FontAwesomeIcon icon={faFilePdf} /> Invoice To Link Global</span>
                    } key="4">
                        <iframe
                          title="invoice"
                          src={pdfURL}
                          style={{ width: '100%', height: '1000px', border: 0 }}
                        />
                    </TabPane>
                  ) : null
                }
              </Tabs>
            </div>
          </Col>
        </Row>
      </div>
  );
}
const MyAccountForm = Form.create({ name: 'myaccount' })(MyAccount);
const UpdatePasswordForm = Form.create({ name: 'updatepassword' })(UpdatePassword);

export default MyAccountForm;
